import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from '../config/config';
import { KeyValueItem } from '../models/keyValueItem.model';
import { MeterType, NewMeter } from '../models/meter.model';
import { ResponsePackage } from '../models/util.model';
import { AssetStatusEnum } from '../models/assetStatus.model';

@Injectable({
  providedIn: 'root',
})
export class MeterValidationService {
  private pathApi = this.config.setting['pathApi'] + 'meterValidation/';
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient, private config: AppConfig) {}
  getAll(dataIn: any): Observable<any> {
    return this.http.post(`${this.pathApi}getAll`, dataIn, {
      observe: 'response',
    });
  }
  download(dataIn: any): Observable<any> {
    return this.http.post(`${this.pathApi}download`, dataIn, {
      observe: 'response',
    });
  }
  getStats(dataIn: any)   {
    return this.http.post<ResponsePackage<KeyValueItem[]>>(`${this.pathApi}getStats`, dataIn, {
      observe: 'response',
    });
  }
  get(meterId: number) {
      return this.http.get<ResponsePackage<any>>(`${this.pathApi}${meterId}`, {
          headers: this.headers,
          observe: 'response',
      });
  }

  approveMeterValidation(obj:any):Observable<any>{
    return this.http.post(`${this.pathApi}approveMeterValidation`, obj);
  }
  
  rejectMeterValidation(obj:any):Observable<any>{
    return this.http.post(`${this.pathApi}rejectMeterValidation`, obj);
  }
}
